import axios from 'axios'

const InventoryTransferService = {
  async get (params = {}) {
    return axios.get('audit/inventory-transfers', { params })
  },

  async post (params) {
    return axios.post('audit/inventory-transfers', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`audit/inventory-transfers/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`audit/inventory-transfers/${data.id}`, { data })
  }
}

export default InventoryTransferService
